var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgLogoMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 69,
    viewBox: "0 0 81 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6924 53.36L30.6973 68.218L30.6641 14.2324C30.6595 6.78977 36.6914 0.753906 44.1337 0.753906H80.4323L68.6414 18.8685H58.4273C54.7077 18.8685 51.6924 21.8839 51.6924 25.6036V53.36Z",
    fill: "white",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2163 14.2376C27.2163 21.6844 21.1797 27.7213 13.7331 27.7213C6.28661 27.7213 0.25 21.6844 0.25 14.2376C0.25 6.79076 6.28661 0.753906 13.7331 0.753906C21.1797 0.753906 27.2163 6.79076 27.2163 14.2376Z",
    fill: "white",
    fillOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.676 53.3643L41.3359 60.6833V17.6493C41.3359 12.9997 45.105 9.23047 49.7545 9.23047H74.9055L68.6311 18.8707H58.4109C54.6913 18.8707 51.676 21.8861 51.676 25.6058V53.3643Z",
    fill: "white",
    fillOpacity: 0.05
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLogoMobile);
export default __webpack_public_path__ + "static/media/bg-logo-mobile.193bbd33698eef26e44f1539ba83f0da.svg";
export { ForwardRef as ReactComponent };